import { View, TouchableOpacity, StyleSheet } from 'react-native'
import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { tierColor, ROMAN } from '../../lib/badges'
import BadgeMedal from './BadgeMedal'

// Fila delle medaglie della vetrina (fino a 3). Toccandola si apre l'album.
export default function ShowcaseRow({ items, size = 34, onPress }) {
  const router = useRouter()
  const { t } = useTranslation()
  if (!items?.length) return null
  const names = items.map(b => b.max_level > 1 ? `${t(`badges.fam.${b.category}.title`)} ${ROMAN[b.level - 1] ?? b.level}` : t(`badges.fam.${b.category}.title`)).join(', ')
  return (
    <TouchableOpacity
      onPress={onPress ?? (() => router.push('/Leagues/badges'))}
      activeOpacity={0.75}
      accessibilityRole="button"
      accessibilityLabel={`${t('badges.showcase_a11y')}: ${names}`}
      style={s.row}
    >
      {items.map(b => <BadgeMedal key={b.code} icon={b.icon_key} color={tierColor(b.level, b.max_level)} size={size} />)}
    </TouchableOpacity>
  )
}

const s = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 6, minHeight: 44, alignSelf: 'flex-start' },
})
